import { GrClose } from "react-icons/gr";
import './NoticeBox.css'

function NoticePopup({children, Id, Title="Notice", NoticeType="Notice", OnExit, OnHover, OnUnhover}) {
    const NoticeTypes = [
        "Notice",
        "Info",
        "Success",
        "Warning",
        "Error",
        "Hidden"
    ]
    const SelectedNoticeType = (NoticeTypes.find(n => n === NoticeType) === undefined) ? "Hidden" : NoticeType;
    return (
        <div 
        key={Id}
        className={SelectedNoticeType}
        onMouseEnter={OnHover}
        onMouseLeave={OnUnhover}
        >
            <div className="NoticeText">
                <h3>{Title}</h3>
                <p>{(children === undefined) ? "No Message Provided" : children}</p>
            </div>
            <div className="CancelNotice">
                <GrClose onClick={OnExit}/>
            </div>
        </div>
    );
}

export default NoticePopup;